import { ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'

export const isMultiVariantProduct = (
    productVariants: ProductVariant[]
): productVariants is Required<ProductVariant>[] =>
    productVariants.length > 1 || !productVariants.some(({ name }) => name === undefined)
